import { ReactElement } from 'react';
import { Stack, Typography } from '@mui/material';

const ReportsHeatmapSectionNotVisits = (): ReactElement => {
  return (
    <Stack height="100%" justifyContent="center" alignItems="center">
      <Typography variant="h6" fontWeight="bold">
        No cuenta con pedidos en los últimos 60 días. Importe pedidos para
        visualizar el gráfico.
      </Typography>
    </Stack>
  );
};

export default ReportsHeatmapSectionNotVisits;
